import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import FlexView from 'react-flexview/lib';
import { GridResultsScreen } from './Grid/GridResultsScreen';
import {EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiSwitch} from '@elastic/eui';
import FormularioSociedades from './Formulario/container';
import { ActionType, CREATE, UPDATE } from './constants';
import { Action } from '../../components/Menus/interface';
import { Menu } from '../../components/Menus';
import ModalApp from '../../components/Modal';

interface Props {
  data: any;
  handleCreate(sociedad: any): any;
  handleRemove(idSociedad: string): any;
  handleUpdate(idActual:string ,sociedad: any): any;
}

const SociedadesScreen = (props: Props) => {
  const ref:any = useRef();
  let { data, handleCreate, handleRemove, handleUpdate } = props;
  let [isModalVisible, setIsModalVisible] = useState(false);
  let [selected, setSelected] = useState<any>(undefined);
  let [actionType, setActionType] = useState<ActionType>(CREATE);
  let [showOnlyNoConfig, setShowOnlyNoConfig] = useState<boolean>(false)

  useEffect(()=>{closeModal();setSelected(undefined)},[data])

  const closeModal = () => setIsModalVisible(false);
  const showModal = () => setIsModalVisible(true);

  const prepareCreate = useCallback(() => {
    setActionType(CREATE);
    showModal();
  },[])

  const prepareEdit = useCallback(() => {
    setActionType(UPDATE);
    showModal();
  },[])

  const onCreate = useCallback((newData: any) => {
    if (newData && handleCreate) {
      handleCreate(newData)
    }
  },[handleCreate])

  const onRemove = useCallback(() => {
    if (selected && handleRemove) {
      handleRemove(selected.idSociedad)
    }
  },[selected, handleRemove])

  const onUpdate = useCallback((newData: any) => {
    if (handleUpdate && newData) {
      handleUpdate(newData.idActual, newData.dataSoc)
    }
  },[handleUpdate])

  const onSelected = (selection: any) => {
    setSelected(selection[0])
  }

  const onFilterClear = () => { 
    ref.current && ref.current.onFilterClear()
  }

  const getSelected = useMemo(() =>{
    return actionType.tipo === "U" ? selected : undefined;
  },[actionType,selected])

  const getHandle = useCallback(() =>{
    if(actionType.tipo === "I"){
      return onCreate
    }else{
      return onUpdate
    }
  },[actionType,onCreate,onUpdate])


  const Actions: Action[] = useMemo(()=>[
    {handle:onFilterClear,text:"Limpiar Filtro",size:"s", isDisabled: false, className: "btnFilterClear"},
    {handle:onRemove,text:"Eliminar Selección",color:"danger",size:"s", isDisabled:(selected===undefined)},
    {handle:prepareEdit,text:"Editar Selección",color:"secondary",size:"s",isDisabled:(selected===undefined)},
    {handle:prepareCreate,text:"Nueva Sociedad",color:"primary",size:"s", isDisabled:false}
  ],[selected, onRemove, prepareCreate, prepareEdit])

  const contentModal = useCallback(() =>  <FormularioSociedades handle={getHandle()} selected={getSelected} onClose={closeModal}/>,[getHandle,getSelected])
  const modal = useMemo(() => <ModalApp isOpen={isModalVisible} title={actionType.title} onClose={closeModal} content={contentModal()}/> ,[isModalVisible,actionType,contentModal])

  const getView = useMemo(() => {
    return (
      <>
        <GridResultsScreen
          data={data}
          selector={false}
          menu={false}
          onSelected={onSelected}
          onChange={onUpdate}
          ref={ref}
          externalFilter={showOnlyNoConfig}
        />
        { modal }
      </>
    )
  },[data,modal,onUpdate,showOnlyNoConfig])


  return(
    <>
    <EuiFlexGroup alignItems={'center'} justifyContent="flexStart" className="filter" wrap>
        {/* <EuiFlexItem grow={false}>
          <EuiFlexGroup style={{backgroundColor:'#ffdc9c',border:'1px solid #ffdc9c',boxShadow:externalFilter&&externalFilter.expatriadosNoFacturables ? '0px 0px 7px #005c9b' : 'none'}} gutterSize="s" alignItems="center" justifyContent="flexStart" >
            <EuiFlexItem><EuiText size='xs'>{translate('expatriado-sin-configurar')}</EuiText></EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem> */}

        <EuiFlexItem grow={false}>
          <EuiFlexGroup style={{backgroundColor:'#ff7e62',border:'1px solid #ff7e62',boxShadow:showOnlyNoConfig ? '0px 0px 7px #005c9b' : 'none'}} gutterSize="s" alignItems="center" justifyContent="flexStart" >
            <EuiFlexItem>
              <EuiSwitch id='' label={`Solo no configurados`} checked={showOnlyNoConfig} onChange={(e)=>setShowOnlyNoConfig(!showOnlyNoConfig)}/>
            </EuiFlexItem>
            {/* <EuiFlexItem><EuiText size='xs'></EuiText></EuiFlexItem> */}
          </EuiFlexGroup>
          {/* <ExternalFilterUsers handleExternalFilter={setExternalFilter} showNoExpatriados={true}/> */}
        </EuiFlexItem>
        <EuiFlexItem>
          {<Menu actions={Actions} className="actions"/>}
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiSpacer size="m" />
      {getView}
    </>
  )

  // return (
  //   <FlexView column basis="100%">
  //       <FlexView column shrink={0} basis="50%" vAlignContent="center" hAlignContent="right">
  //         <Menu actions={Actions}/>
  //         <EuiSpacer size="s" />
  //       </FlexView>
  //     <FlexView grow={1} shrink={1} basis="auto">
  //       <FlexView column shrink={0} basis="100%">
  //         {getView}
  //       </FlexView>
  //     </FlexView>
  //   </FlexView>
  // );
};

export default SociedadesScreen;
